import React, { useCallback, useMemo, useState } from 'react'
import { Icon } from '@manychat/icons'

import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon/TextWithIcon'

import { Wrapper } from './EmptyNode.styles'

interface EmptyNodeProps {
  id: string
  text: string
  iconComponent?: Icon | null
  hoverBackground?: string
  hoverBorderColor?: string

  onClick?: () => void
}

export const EmptyNode = ({
  id,
  text,
  iconComponent,
  hoverBorderColor = sharedStyles.Colors.PRIMARY,
  hoverBackground = sharedStyles.Colors.PRIMARY_MUTED,
  onClick,
}: EmptyNodeProps) => {
  const [isHover, setHover] = useState(false)

  const iconString = useMemo(
    () =>
      iconComponent
        ? convertToIconString(iconComponent, {
            size: sharedStyles.IconSizes.MEDIUM_LARGE,
            color: sharedStyles.Colors.Tints.NEUTRAL[2],
          })
        : null,
    [iconComponent],
  )

  const handleMouseOver = useCallback(() => setHover(true), [])

  const handleMouseOut = useCallback(() => setHover(false), [])

  const handleOnClick = useCallback(() => onClick !== undefined && onClick(), [onClick])

  const hoverStyles = useMemo(() => {
    return isHover
      ? {
          backgroundColor: hoverBackground,
          borderColor: hoverBorderColor,
        }
      : undefined
  }, [isHover, hoverBorderColor, hoverBackground])

  return (
    <view
      name={id}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      onClick={handleOnClick}
      style={Wrapper}
    >
      <ContentContainer isEmpty style={hoverStyles}>
        <TextWithIcon icon={iconString} empty>
          {text}
        </TextWithIcon>
      </ContentContainer>
    </view>
  )
}
